var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.21 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #10519e;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.6,261c-13.04,0-23.6-10.57-23.6-23.6V94.63c0-13.04,10.57-23.6,23.6-23.6s23.6,10.57,23.6,23.6v142.77c0,13.04-10.57,23.6-23.6,23.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.6,
    cy: 26.78,
    r: 21.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset41);
export default __webpack_public_path__ + "static/media/Asset 41.9b65829fb458658df9125639f96cf0dc.svg";
export { ForwardRef as ReactComponent };